import { Component, Input, ViewChild, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { Credits, Projects, Foaming } from '@usimweb/core/models';
import { CdkDetailRowDirective } from './cdk-detail-row.directive';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
    selector: 'usimweb-table-credits',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './table-credits.component.html',
    styleUrls: ['./table-credits.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class TableCreditsComponent {
  @Input() data!: any;

  @Output() changeChart: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(CdkDetailRowDirective) dirs!: CdkDetailRowDirective;

  public dataTableSource!: MatTableDataSource<Projects>;
  public selection = new SelectionModel<any>(true, []);
  public materialColumns: string[] = ['project', 'simulations', 'cpu_hours', 'support', 'credits'];

  private collapseBlocked = false;

  public isExpanded: boolean = false;

  public expanded(uuid: string) {
    this.collapseBlocked = true;

    this.isExpanded = !this.isExpanded;
    this.changeChart.emit({ showVersion: this.isExpanded, uuid: uuid });
  }

  private filterDraftsVersions(projects: Projects[]): Projects[] {
    projects.forEach((project: Projects, projectIndex: number) => {
      const versions = project.versions as any[];

      const tmpVersion: Foaming[] = [];

      versions.forEach((version: Foaming) => {
        //FIX ME
        // if (version.status != undefined && version.status.simulation !== 'draft') {
        //   tmpVersion.push(version);
        // }
      });

      projects[projectIndex].versions = tmpVersion as [];
      project.versions_amount = project.versions?.length || 0;

      (project.credits as Credits).simulation = Math.round((project.credits as Credits).simulation);
      (project.credits as Credits).support = Math.round((project.credits as Credits).support);
    });

    return projects;
  }

  // FIXME
  private updateTable() {
    // this.projects.forEach((project: Projects) => {
    //   project.expanded = true;
    //   (project.credits as Credits).simulation = Math.round((project.credits as Credits).simulation);
    //   (project.credits as Credits).support = Math.round((project.credits as Credits).support);
    //   project.versions_amount = project.versions?.length || 0;
    // });
    //this.projects = this.filterDraftsVersions(Helper.Array.deepCopy(this.projects));
    // this.projects = this.projects.filter((x) => x.versions?.length || 0 > 1);
    //  this.dataTableSource = new MatTableDataSource<Projects>(this.projects);
  }

  // FIXME
  public collapse() {
    // setTimeout(() => {
    //   if (!this.collapseBlocked) {
    //     this.dataTableSource.data.forEach((project) => {
    //       if (project.expanded) {
    //         this.dirs.closeAll();
    //         this.isExpanded = false;
    //         this.changeChart.emit({ showVersion: false, uuid: null });
    //       }
    //     });
    //   }
    //   this.collapseBlocked = false;
    // }, 100);
  }
}
